import { useId, useState } from 'react';
import type { GameId } from '@urbanrats/contracts';
import { can } from '@urbanrats/ops-core';
import { useCtx } from '../lib.ts';

/** Stops NEW round openings only; running rounds finish and settle. Audited with a reason. */
export function PauseControl({ gameId }: { gameId: GameId }) {
  const { data, user, backend, refresh } = useCtx();
  const g = data.games.find((x) => x.gameId === gameId)!;
  const [reason, setReason] = useState('');
  const [msg, setMsg] = useState<string | null>(null);
  const id = useId();
  if (!can(user, 'action.pause')) return <span className="muted">{g.paused ? 'New rounds paused' : 'Running'}</span>;
  return (
    <div className="pause" data-testid={`pause-${gameId}`}>
      <p className="note">Pausing stops new rounds from opening. Rounds already running finish, settle and refund normally; accepted bets are not touched.</p>
      <label htmlFor={id}>Reason (min 10 chars)</label>
      <input id={id} value={reason} onChange={(e) => setReason(e.target.value)} data-testid="pause-reason" />
      <button
        type="button"
        className={`btn ${g.paused ? '' : 'danger'}`}
        onClick={async () => {
          const r = await backend.setGamePaused(user, gameId, !g.paused, reason);
          setMsg(r.ok ? r.value : r.error);
          if (r.ok) setReason('');
          refresh();
        }}
        data-testid="pause-toggle"
      >
        {g.paused ? `Resume new ${g.title} rounds` : `Pause new ${g.title} rounds`}
      </button>
      {msg && (
        <p role="status" className="status-msg">
          {msg}
        </p>
      )}
    </div>
  );
}
